module.exports = __webpack_public_path__ + "static/media/fire-flame.fcbea208.gif";